import * as React from "react";
import styled from "styled-components";
import { select, useSelect } from "@hubper/theme";

import Tile from "./elements/Tile";
import Top from "./elements/Top";
import Bottom from "./elements/Bottom";

import { useSpring, animated } from "react-spring";

const AnimatedTop = animated(Top);

function useBlingAnimation() {
  const animationStyle = useSpring({
    from: {
      num: 0
    },
    to: async (next: any) => {
      while (1) {
        await next({ from: { num: 0 }, to: { num: 100 } });
        await wait(1100);
      }
    },
    reset: true,
    config: {
      duration: 600
    }
  });

  return animationStyle;
}

const Title = styled(animated.div)`
  background-color: ${select.color(["grey", 1])};
  width: 120px;
  height: 16px;
  margin-top: 4px;
  margin-bottom: 2px;
  border-radius: 2px;
`;
const Subtitle = styled(animated.div)`
  background-color: ${select.color(["grey", 0])};
  width: 80px;
  height: 14px;
  border-radius: 2px;
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
};

const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

function interpolateBackground(colorLight: string, colorDark: string) {
  return (x: number) => {
    return `linear-gradient(45deg, ${colorLight} 0%, ${colorLight} ${
      x - 20 > 0 ? (x - 20 >= 80 ? 100 : x - 20) : 0
    }%, ${colorDark} ${x}%, ${colorDark} ${x + 5}%, ${colorLight} ${
      x + 25 > 100 ? 100 : x + 25
    }%, ${colorLight} 100%)`;
  };
}

function AdminActivityTile({ style, className }: Props, ref: any) {
  const animationStyle = useBlingAnimation();

  const { color } = useSelect();

  return (
    <Tile ref={ref} style={style} className={className} disabled>
      <AnimatedTop
        style={{
          background: (animationStyle as any).num.interpolate(
            interpolateBackground(color(["grey", 0]), "hsl(120, 3%, 98%)")
          )
        }}
      />
      <Bottom
        topLeft={
          <>
            <Title
              style={{
                background: (animationStyle as any).num.interpolate(
                  interpolateBackground(color(["grey", 1]), "hsl(120, 3%, 93%)")
                )
              }}
            />
            <Subtitle
              style={{
                background: (animationStyle as any).num.interpolate(
                  interpolateBackground(color(["grey", 0]), "hsl(120, 3%, 99%)")
                )
              }}
            />
          </>
        }
      />
    </Tile>
  );
}

export default React.forwardRef(AdminActivityTile);
